<template>
  <div class="mytag">
    <header-top v-if="notapp" :goBack="true" :mine='true'></header-top>
    <p class="addtext" ref="title">{{$t('menu.mytag')}}</p>
 	<div class="mytag-main">
 		<ul>
 			<li v-for="(item,index) in petlist" @click="open(item)">
 				<img :src='item.petDto.portrait==""? "../../../static/img/headerbg.png":item.petDto.portrait' alt="" />
 				<span>{{item.petDto.name}}</span>
 			</li>
 		</ul>
 		<div v-if="mytagnull" class="mytag-null">
 			<span><img src="../../../static/img/mytagnullbg.png" alt="" /></span>
 			<template v-if='notapp'>
 			<span>{{$t('device.nodevice')}}</span>
 			<span>{{$t('device.content')}}</span>
 			<span>{{$t('device.contentnum')}}</span>
 			</template>
 			<template v-if='!notapp'>
 			<span>{{$t('device.nodevice')}}</span>
 			<span>{{$t('device.scanning')}}</span>
 			</template>
 		</div>
 	</div>
  </div>
</template>
<script>
import headerTop from "../../components/header";
import Qs from "qs";
import { getDevices} from "../../deviceApi/index.js";
import Axios from 'axios';
export default {
  name: "mytags",
  data() {
    return {
  		petlist: "",
  		imgurl:require("../../../static/img/headerbg.png"),
  		mytagnull:false,
  		notapp:true,
  		info:{
            menuC:'',
            cords:'',
            lostpetinfos:'',
            lostsign:'',
            ifedit:'',
            isable:'',
            lossbtn:'',
            code:'',
        }
    };
  },
  components: {
    headerTop,
  },
  mounted() {

  },
  created() {
  	if(localStorage.fromapp){//是否在app内打开
  		this.notapp=false;
  	}
		this.getDevices();
  },
  methods: {
  		getDevices(){
  			var params = Qs.stringify({
          		type : "TAG",
        	});
        //获得所有宠物
  			getDevices(params)
            .then(res => {
            	if (res.data.header.status == 1000) {
            		console.log(res.data.data)
                if(res.data.data ==""){
							  		this.mytagnull = true;
							  	}else{
							  		let tag=[];
							  		for(let i =0;i<res.data.data.length;i++){
							  			if(res.data.data[i].device.type=='TAG'&& res.data.data[i].petDto){
							  				tag.push(res.data.data[i])
							  			}
							  		}
							  		console.log(tag.length)
							  		if(tag.length==0){this.mytagnull = true;}
							  		this.petlist = tag;
							  	}
               }else{
	               	this.$alert("<p>" + res.data.header.message + "</p>", {
										confirmButtonText: this.$t("prompt.sure"),
										dangerouslyUseHTMLString: true
										});
									return false;
               }
            })
            .catch(error => {
                console.log(error);
            });
  		},
    	open(item){
    		let code = item.device.deviceCode;
    		localStorage.setItem('codeId',code)
    		localStorage.setItem('token',localStorage.token)
				this.$router.push('/showInformation?accessToken='+localStorage.token+'&deviceCode='+code)
    	},
    },
    
  
};
</script>
<style>

</style>
<style scoped>

.addtext {
  text-align: center;
  font-size: 1rem;
  color: #333333;
  padding: 20px 0;
  border-bottom: 1px solid #e1e1e1;
}

.mytag-main ul li{
  width: 100%;
  height: 3.5rem;
  line-height: 3.5rem;
  font-size: .8rem;
  color: #6d6d6d;
  border-bottom: solid 1px #e1e1e1;	
}

.mytag-main ul li img{
	width: 2.5rem;
	height: 2.5rem;
	margin-left: 1.5rem;
	margin-right: .5rem;
	vertical-align: middle;
	border-radius: 50%;
}
.mytag-null{
	width: 100%;
}
.mytag-null span img{
    width: 12rem;
    padding: 30px 0;
}
.mytag-null span{
	text-align: center;
	font-size: .9rem;
	color: #9a9a9a;
	line-height: 1.4rem;
	display: inherit;
}
@media screen and (min-width: 320px) and (max-width: 568px) {

}
@media screen and (min-width: 375px) and (max-width: 667px) {

}
@media screen and (min-width: 414px) {

}

</style>



// WEBPACK FOOTER //
// src/m_page/myAccount/mytag.vue